import RedirectUI, { getPathNewUi } from 'guards/RedirectUI'
import React from 'react'
export default function Imports() {
  const path = getPathNewUi('/platform/invoiceAI/fileImport')
  return <RedirectUI path={path} omitValidation={true} />
}
